export default __webpack_public_path__ + "static/media/acceptInstructions.af6b91c7.gif";